import { render, staticRenderFns } from "./MakePaymentPage.vue?vue&type=template&id=6a25d535&"
import script from "./MakePaymentPage.vue?vue&type=script&lang=js&"
export * from "./MakePaymentPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports